<section class="mt-2">
  <table class="table table-hover white_box shadow" style="margin-top: 10px;">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Text</th>
        <th scope="col">Count</th>
        <th scope="col">Status</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of keywords; let i = index;">
        <th scope="row">{{i + 1}}</th>
        <td>
          {{ item.text }}
        </td>
        <td>
          {{ item.count }}
        </td>
        <td>
          <select class="form-control" (change)="handleApproval($event, item)">
            <option *ngFor="let status of listStatus; let i = index" [value]="i" [selected]="item.isPopular == i">{{ status
              }}</option>
          </select>
        </td>
        <td>
          <div class="btn-group">
            <button class="btn btn-sm btn-danger" (click)="handleDelete(item)">
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<!-- <ng-template #addEditCategory let-modal>
  <div class="modal-header">
      <h4 class="modal-title">Add/editCategory</h4>
      <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
      <div class="row">
          <div class="form-group col-12">
              <label for="exampleInputEmail1">Category Name </label>
              <input type="text" [(ngModel)]="categoryName" class="form-control" placeholder="Enter Category Name">
          </div>
      </div>


      <duv class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary" (click)="AddEditCategorySubmit()">
              Save
          </button>
      </duv>
  </div>
</ng-template> -->